/**************************************************
 * Nombre:       Home_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {INDICADORES, NEGRITA} from "../../../Constantes";
import Tarjeta_Indicador from "../../Tarjetas/Tarjeta_Indicador";
import fondo from "../../../Recursos/fondo_indicadores.png";
import linea from "../../../Recursos/Iconos/ic_raya.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Indicadores = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(180deg, rgba(48, 51, 118, 0.76) 0%, rgba(48, 51, 118, 0.76) 100%),  url(' + fondo + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 12, pb: 24}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontWeight: 400,
                                fontFamily: NEGRITA,
                                fontSize: sCell ? 32 : 40,
                                textAlign: 'center'
                            }}>RESPALDO
                                JURÍDICO
                                AUTORIZADO DESDE EL AÑO 2017 PARA LA GESTIÓN DE
                                CONFLICTOS</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <img src={linea} width={50} height={'auto'} alt={'linea'}/>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontWeight: 300, fontSize: sCell ? 16 : 18, textAlign: 'center'}}>
                                Centro privado, avalado y sujeto a inspección control y vigilancia por el Ministerio de Justicia y el
                                Derecho.
                                Garantizamos seguridad jurídica y celeridad procesal para firmas de abogados, empresas y
                                entidades del Estado.
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 8}}
                            spacing={sCell ? 2 : 8}
                        >

                            {INDICADORES.map((it, index) => (
                                <Grid container size={{xs: 6, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Indicador item={it}/>
                                </Grid>
                            ))}


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Indicadores  